<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              v-if="activeName !== 'memberPay'"
              type="danger"
              >新增</el-button
            >
            <el-button
              v-access:modify
              icon="el-icon-upload2"
              @click="importFromExcel"
              size="small"
              :disabled="isloading"
              v-if="activeName !== 'memberPay'"
              >导入</el-button
            >
            <el-button
              v-access:modify
              icon="el-icon-download"
              @click="exporttoexcel"
              size="small"
              :disabled="isloading"
              v-if="activeName !== 'memberPay'"
              >导出</el-button
            >
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              :disabled="isloading"
              @click="addMemberPay"
              v-if="activeName === 'memberPay'"
              >新增</el-button
            >
            <el-button
              v-access:modify
              icon="el-icon-download"
              size="small"
              :disabled="isloading"
              @click="exportMemberPay"
              v-if="activeName === 'memberPay'"
              >导出</el-button
            >
          </div>
          <div style="float: right">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="btnSearch"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>

      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="个人会员" name="personal">
          <div>
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="presonalData"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="BusinessId"
                label="会员编号"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="UserName"
                label="会员名称"
              ></el-table-column>
              <el-table-column
                prop="Level"
                label="会员级别"
                align="center"
                :formatter="formatterLevel"
                width="100"
              ></el-table-column>
              <el-table-column label="入会时间" align="center" width="140">
                <template slot-scope="scope">
                  {{ (scope.row.ApplyTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Paymentstatus"
                label="缴费状态"
                align="center"
                :formatter="formatterPaymentstatus"
                width="90"
              ></el-table-column>
              <el-table-column
                prop="Status"
                label="会员状态"
                align="center"
                :formatter="formatterStatus"
                width="90"
              ></el-table-column>
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    @click="updatePersonalPayment(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status != 3 && !scope.row.Paymentstatus"
                    >确定缴费</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="updatePersonalRevoke(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status != 3"
                    >撤销</el-button
                  >
                  <!-- <el-button
                    v-access:modify
                    @click="updatePersonalStatus(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status === 3"
                    >启用</el-button
                  > -->
                  <el-button
                    v-access:modify
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="scope.row.IsSystem == true"
                    @click="deletePersonalStatus(scope.row)"
                    type="text"
                    size="mini"
                    >删除</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="downloadimg(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status != 3 && scope.row.Paymentstatus"
                    >下载证书</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-wapper">
              <OfPagination
                :total="total"
                :pageSize="pageSize_personal"
                :currentPage="currentPage_personal"
                @onSizeChange="handleSizeChange"
                @onCurrentChange="handleCurrentChange"
              ></OfPagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="团体会员" name="group">
          <div>
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="groupData"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="BusinessId"
                label="会员编号"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="UnitName"
                label="会员名称"
              ></el-table-column>
              <el-table-column
                prop="Level"
                label="会员级别"
                align="center"
                :formatter="formatterLevel"
                width="90"
              ></el-table-column>
              <el-table-column label="入会时间" align="center" width="140">
                <template slot-scope="scope">
                  {{ (scope.row.ApplyTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                label="缴费状态"
                align="center"
                :formatter="formatterPaymentstatus"
                width="105"
              ></el-table-column>
              <el-table-column
                prop="Status"
                label="会员状态"
                align="center"
                :formatter="formatterStatus"
                width="90"
              ></el-table-column>
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    @click="updateGroupPayment(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status != 3 && !scope.row.Paymentstatus"
                    >确定缴费</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="scope.row.Status != 3"
                    @click="updateGroupRevoke(scope.row)"
                    type="text"
                    size="mini"
                    >撤销</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >编辑</el-button
                  >
                  <!-- <el-button
                    v-access:modify
                    @click="updateGroupStatus(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status === 3"
                    >启用</el-button
                  > -->
                  <el-button
                    v-access:modify
                    v-if="scope.row.IsSystem == true"
                    @click="deleteGroupStatus(scope.row)"
                    type="text"
                    size="mini"
                    >删除</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="downloadimgGroup(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.Status != 3 && scope.row.Paymentstatus"
                    >下载证书</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-wapper">
              <OfPagination
                :total="total"
                :pageSize="pageSize_group"
                :currentPage="currentPage_group"
                @onSizeChange="handleSizeChange"
                @onCurrentChange="handleCurrentChange"
              ></OfPagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="会员缴费" name="memberPay">
          <div>
            <el-table
              border
              :max-height="tableMaxHeight()"
              v-loading="isloading"
              :data="memberPay"
            >
              <el-table-column
                prop="OrderNo"
                label="缴费单号"
                width="200"
              ></el-table-column>
              <el-table-column prop="Name" label="会员名称"></el-table-column>
              <el-table-column
                prop="Level"
                label="会员级别"
                align="center"
                :formatter="formatterLevel"
                width="105"
              ></el-table-column>
              <el-table-column
                prop="Amount"
                label="金额"
                align="right"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="BankReceiveTime"
                label="缴费时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.BankReceiveTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="query(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-wapper">
              <OfPagination
                :total="total"
                :pageSize="searchModel.pageSize"
                :currentPage="searchModel.pageIndex"
                @onSizeChange="handleSizeChange"
                @onCurrentChange="handleCurrentChange"
              ></OfPagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </BasePage>
    <ModulePersonalEdit
      v-if="formVisible_personal"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModulePersonalEdit>
    <ModuleGroupEdit
      v-if="formVisible_group"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleGroupEdit>
    <ModuleExport
      v-if="formexport"
      @exportCallBack="exportCallBack"
    ></ModuleExport>
    <ModuleMemberPayQuery
      v-if="showMemberPay"
      @formCallBack="formCallBack"
      :dataForm="formData"
    ></ModuleMemberPayQuery>
    <MemberPay
      v-if="showAddMemberPay"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
      :dataForm="formData"
    ></MemberPay>
    <el-dialog
      title="导入"
      :visible.sync="dialogVisible"
      width="20%"
      :before-close="handleClose"
    >
      <div class="importTemplate">
        <el-form label-position="right" label-width="90px">
          <el-form-item label="下载模板：">
            <a
              href="/static/member.xlsx"
              download="会员导入模板.xlsx"
              style="color: red"
              >会员导入模板</a
            >
          </el-form-item>
          <el-form-item label="导入模板：">
            <el-upload
              v-if="activeName !== 'memberPay'"
              class="upload-demo"
              :action="action"
              :headers="headers"
              accept=".xlsx,.xls"
              :before-upload="onCheckFile"
              :on-success="onFileUpLoad"
            >
              <el-button size="small" type="danger" round :disabled="isloading"
                >导 入</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page"
import ModulePersonalEdit from "@/modules/zjrc/pages/users/member/personaledit"
import ModuleGroupEdit from "@/modules/zjrc/pages/users/member/groupedit"
import ModuleMemberPayQuery from "@/modules/zjrc/pages/users/member/memberquery"
import ModuleExport from "@/modules/zjrc/pages/users/member/export"
import OfPagination from "@/components/controls/of_pagination/of_pagination"
import OfSearch from "@/components/controls/of_search/of_search"
import MemberPay from "@/modules/zjrc/pages/users/member/memberPay"
import api from "@/modules/zjrc/api"
import { formatData } from "@/utils/index"
import store from "@/store"
import { saveAs } from "file-saver"
export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",

      formTitle: "",
      formData: {},

      total: 0,

      searchModel: {
        searchKey: "",
        pageIndex: 1,
        pageSize: 15,
      },
      activeName: "personal",

      presonalData: [], //个人会员
      currentPage_personal: 1,
      pageSize_personal: 15,
      formVisible_personal: false,

      groupData: [], //团体会员
      currentPage_group: 1,
      pageSize_group: 15,
      formVisible_group: false,
      placeholder: "会员名称",
      formexport: false,
      memberPay: [],
      showMemberPay: false,
      headers: {
        "OF-Authorization": store.getters.GetUserToken,
      },
      action: "/api/PersonalMember/Import",
      imgsrc: "",
      dialogVisible: false,
      showAddMemberPay: false,
    }
  },
  components: {
    BasePage,
    OfPagination,
    ModulePersonalEdit,
    ModuleGroupEdit,
    OfSearch,
    ModuleExport,
    ModuleMemberPayQuery,
    MemberPay,
  },
  mounted() {
    this.loadPersonalData()
  },
  computed: {
    Status() {
      return (rowData) => {
        return rowData.Status == 0 ? true : false
      }
    },
  },
  methods: {
    addMemberPay() {
      this.showAddMemberPay = true
      this.formTitle = "新增会员缴费"
      this.formData = { Type: 1 }
    },
    exportMemberPay() {
      saveAs("/api/MemberPay/ExportMemberPay", "会员缴费.xls")
    },
    handleClose() {
      const vm = this
      vm.dialogVisible = false
    },
    importFromExcel() {
      const vm = this
      vm.dialogVisible = true
    },
    onCheckFile(file, status) {
      const vm = this
      let size = file.size / 1024 / 1024
      vm.isloading = true
      if (size > 100) {
        this.$message({
          type: "error",
          message: "附件大小必须小于100M",
        })
        status(false)
        vm.isloading = false
        return
      }
    },
    onFileUpLoad(res) {
      let vm = this
      if (res.Code === 0) {
        this.searchModel.pageIndex = 1
        this.searchModel.searchKey = ""
        vm.loadPersonalData()
        vm.$message({
          type: "success",
          message: "导入成功",
        })
        vm.dialogVisible = false
      } else {
        vm.$message({
          type: "error",
          message: res.Message,
        })
      }
      vm.isloading = false
    },
    //初始化个人会员数据
    loadPersonalData() {
      this.isloading = true
      let params = {
        pageIndex: this.searchModel.pageIndex,
        pageSize: this.searchModel.pageSize,
        SearchKey: this.searchModel.searchKey,
      }
      api.QueryPersonalMember(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total
          this.presonalData = rep.data.Data.rows
          this.presonalData.forEach((item) => {
            item.type = "个人"
          })
        }
        this.isloading = false
      })
    },
    //初始化团体会员信息
    loadGroupData() {
      this.isloading = true
      let params = {
        pageIndex: this.searchModel.pageIndex,
        pageSize: this.searchModel.pageSize,
        SearchKey: this.searchModel.searchKey,
      }
      api.QueryGroupMember(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total
          this.groupData = rep.data.Data.rows
          this.groupData.forEach((item) => {
            item.type = "团体"
          })
        }
        this.isloading = false
      })
    },
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData)
      this.formData.ApplyTime = this.formData.ApplyTime * 1000
      this.formData.Birthday = this.formData.Birthday * 1000
      this.formTitle = "会员管理详情"
      if (this.activeName == "personal") {
        this.formVisible_personal = true
      } else {
        this.formVisible_group = true
      }
    },
    //回调
    formCallBack(data) {
      let that = this
      that.formVisible_personal = false
      that.formVisible_group = false
      that.showMemberPay = false
      that.showAddMemberPay = false
      if (data) {
        switch (that.activeName) {
          case "personal":
            that.loadPersonalData()
            break
          case "group":
            that.loadGroupData()
            break
          case "memberPay":
            that.loadMemberPay()
            break
        }
      }
    },
    loadMemberPay() {
      let that = this
      that.isloading = true
      let params = {
        pageIndex: that.searchModel.pageIndex,
        pageSize: that.searchModel.pageSize,
        SearchKey: that.searchModel.searchKey,
      }
      api.QueryMemberPay(params).then((res) => {
        if (res.data.Code === 0) {
          that.memberPay = res.data.Data.rows
          that.total = res.data.Data.total
        }
        that.isloading = false
      })
    },
    handleClick(tab, event) {
      let that = this
      that.searchModel.pageIndex = 1
      switch (tab.name) {
        case "personal":
          that.loadPersonalData()
          break
        case "group":
          that.loadGroupData()
          break
        case "memberPay":
          that.loadMemberPay()
          break
      }
    },
    query(rowData) {
      let that = this
      that.formData = rowData
      that.showMemberPay = true
    },
    //切换每页显示条数
    handleSizeChange(pageSize) {
      let that = this
      that.searchModel.pageIndex = 1
      that.searchModel.pageSize = pageSize
      switch (that.activeName) {
        case "personal":
          that.loadPersonalData()
          break
        case "group":
          that.loadGroupData()
          break
        case "memberPay":
          that.loadMemberPay()
          break
      }
    },
    //切换页码
    handleCurrentChange(pageIndex) {
      let that = this
      if (that.total > that.searchModel.pageSize) {
        that.searchModel.pageIndex = pageIndex
        switch (that.activeName) {
          case "personal":
            that.loadPersonalData()
            break
          case "group":
            that.loadGroupData()
            break
          case "memberPay":
            that.loadMemberPay()
            break
        }
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight
      var tableMaxHeight = 0
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363
      }
      return tableMaxHeight
    },
    //搜索
    btnSearch() {
      if (this.activeName == "personal") {
        this.loadPersonalData()
      } else {
        this.loadGroupData()
      }
    },
    //新增
    add() {
      if (this.activeName == "personal") {
        this.formTitle = "新建个人会员"
        this.formData = {}
        this.formVisible_personal = true
      } else {
        this.formTitle = "新建团体会员"
        this.formData = {}
        this.formVisible_group = true
      }
    },
    //会员等级
    formatterLevel(rowData) {
      return formatData(rowData.Level, this.memberLevel)
    },
    //缴费状态
    formatterPaymentstatus(rowData) {
      return rowData.Paymentstatus ? "已缴费" : "未缴费"
    },
    //会员状态
    formatterStatus(rowData) {
      return rowData.Status === 3 ? "已撤销" : "正常"
    },
    //更新个人账户状态
    updatePersonalStatus(rowData) {
      var warm = rowData.Status == 0 ? "您确定禁用账户？" : "您确定启用账户？"
      this.$confirm(warm, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true
        rowData.Status = rowData.Status == 0 ? 1 : 0
        let params = { Id: rowData.Id, Status: rowData.Status }
        api.UpdatePersonalMemberStatus(params).then((rep) => {
          this.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadPersonalData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    //删除个人账户
    deletePersonalStatus(rowData) {
      this.$confirm("您确定删除账户？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true
        rowData.Status = 2
        let params = { Id: rowData.Id, Status: rowData.Status }
        api.UpdatePersonalMemberStatus(params).then((rep) => {
          this.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadPersonalData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    //更新团体账户状态
    updateGroupStatus(rowData) {
      var warm = rowData.Status == 0 ? "您确定禁用账户？" : "您确定启用账户？"
      this.$confirm(warm, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true
        rowData.Status = rowData.Status == 0 ? 1 : 0
        let params = { Id: rowData.Id, Status: rowData.Status }
        api.UpdateGroupMemberStatus(params).then((rep) => {
          this.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadGroupData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    //删除团体账户
    deleteGroupStatus(rowData) {
      this.$confirm("您确定删除账户？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true
        rowData.Status = 2
        let params = { Id: rowData.Id, Status: rowData.Status }
        api.UpdateGroupMemberStatus(params).then((rep) => {
          this.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadGroupData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    exporttoexcel() {
      this.formexport = true
    },
    exportCallBack(data) {
      this.formexport = false
    },
    //撤销个人账户
    updatePersonalRevoke(rowData) {
      this.$confirm("您确定撤销账户？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true
        rowData.Status = 3
        let params = { Id: rowData.Id, Status: rowData.Status }
        api.UpdatePersonalMemberStatus(params).then((rep) => {
          this.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadPersonalData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    //撤销团体用户
    updateGroupRevoke(rowData) {
      this.$confirm("您确定撤销账户？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true
        rowData.Status = 3
        let params = { Id: rowData.Id, Status: rowData.Status }
        api.UpdateGroupMemberStatus(params).then((rep) => {
          this.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadPersonalData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    updatePersonalPayment(rowData) {
      let vm = this
      vm.$confirm("是否确定已收到会员缴费？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.isloading = true
        let params = { Id: rowData.Id }
        api.UpdatePaymentstatusPersonal(params).then((rep) => {
          vm.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadPersonalData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    updateGroupPayment(rowData) {
      let vm = this
      vm.$confirm("是否确定已收到会员缴费？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.isloading = true
        let params = { Id: rowData.Id }
        api.UpdatePaymentstatusGroup(params).then((rep) => {
          vm.isloading = false
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            })
            this.loadPersonalData()
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    downloadimg(rowData) {
      let request = { memberId: rowData.Id }
      api.QueryPersonalCertificate(request).then((res) => {
        if (res.data.type === "application/json") {
          const fileReader = new FileReader()
          fileReader.onload = () => {
            const result = JSON.parse(fileReader.result)
            const msg = result.Message.substring(0, result.Message.indexOf("/"))
            this.$message.error(msg)
          }
          fileReader.readAsText(res.data)
        } else {
          const blob = new Blob([res.data])
          saveAs(blob, "会员证书.jpg")
        }
      })
    },
    downloadimgGroup(rowData) {
      let request = { memberId: rowData.Id }
      api.QueryGroupCertificate(request).then((res) => {
        if (res) {
          const blob = new Blob([res.data])
          saveAs(blob, "会员证书.jpg")
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.el-select >>> .el-input__inner {
  width: 2.5rem;
}
.el-date-editor >>> .el-range-separator {
  padding: 0 !important;
  line-height: 120% !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-row >>> .of-search {
  float: left;
  padding-right: 5%;
}
.upload-demo {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  line-height: 30.6px;

  /deep/ .el-upload__input {
    display: none;
  }

  /deep/.el-upload-list {
    display: none;
  }
}
</style>
<style>
.select {
  float: left;
  margin-left: 1%;
}
</style>
